import { createSelector } from 'reselect';
import type { RootState } from './types';

const getAuth = (state: RootState) => {
  return state.auth;
};

export const currentUser = createSelector([getAuth], (auth) => {
  return auth.user;
});

export const currentUserACL = createSelector([getAuth], (auth) => {
  return auth.acl || {};
});
